import * as React from 'react';

import { Select, SelectProps } from 'antd';
import { useAppDispatch, useAppSelector } from '@reduxHelpers';

import { supportedLanguages } from '@/i18n/config';
import { updateLanguage } from '@modules/localeModule';

interface LanguagePickerProps extends SelectProps<string> {

}

export const LanguagePicker: React.FC<LanguagePickerProps> = (props) => {
    const dispatch = useAppDispatch();

    const currentLocale = useAppSelector((state) => state.locale.currentLocale);

    return (
        <Select
            {...props}
            onChange={async (newValue) => {
                dispatch(updateLanguage(newValue));
            }}
            value={currentLocale}
            style={{ width: '100%' }}
        >
            {supportedLanguages.map((lang) => {
                return (
                    <Select.Option
                        key={lang.key}
                        value={lang.key}
                    >
                        {lang.title}
                    </Select.Option>
                );
            })}
        </Select>
    );
};